import StatusPill, { StatusPillColour } from "../shared/StatusPill";
import { SALES_QUOTE_STATUS_LABELS, SalesQuoteStatus } from "../../models/SalesQuote";

export function SalesQuoteStatusPill({ status }: { status: SalesQuoteStatus }) {
  const colour =
    status === SalesQuoteStatus.Open
      ? StatusPillColour.Blue
      : status === SalesQuoteStatus.Converted
        ? StatusPillColour.Green
        : StatusPillColour.Neutral;
  return <StatusPill text={SALES_QUOTE_STATUS_LABELS[status] ?? "Unknown"} colour={colour} />;
}
